import { Input } from "antd";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconSearch } from "../../../assets/icon";

const InputSearchBox = ({ placeholder, disabled, width, setText }) => {
  const [textSearch, setTextSearch] = useState("");
  const { t } = useTranslation();
  const style = {
    width,
    height: "3.4rem",
  };
  const handleChange = (e) => {
    setTextSearch(e.target.value);
  };
  return (
    <div onKeyDown={(e) => (e.key === "Enter" ? setText(textSearch) : null)}>
      <Input
        disabled={disabled}
        autoComplete="off"
        className="inputRound searchInPut"
        value={textSearch}
        onChange={handleChange}
        style={style}
        placeholder={t(placeholder)}
        prefix={
          <IconSearch className="pointer" onClick={() => setText(textSearch)} />
        }
      />
    </div>
  );
};

export default InputSearchBox;
